module.exports = "<div class=\"dashboard__content\">\n  <pf-dashboard-grid [forms]=\"forms\"></pf-dashboard-grid>\n</div>\n"